import { v4 as uuid } from 'uuid';
import { WebSocketClient, IWSClientEventSchema, IWSServerSessionEventSchema } from '@cian/chats-api/lib/browser-entry';

/**
 * Регистрация сессии.
 *
 * 1. Отправляет событие с токеном на сервер
 * 2. Ждет ответное событие от сервера, что регистрация прошла успешно
 * 3. В случае если соединение будет закрыто или пройдет >n-времени, то регистрация будет считать не успешной
 *
 * @export
 * @class Registration
 */
export class Registration {
  public uid: string;

  private registerHandlerId: string | null = null;
  private socketCloseHandlerId: string | null = null;
  private registerTimeoutId: NodeJS.Timer | null = null;

  public constructor(
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    private socket: WebSocketClient,
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    private sessionToken: string,
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    private userId: number,
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    private timeout: number = 10000,
  ) {}

  public async register() {
    this.uid = uuid();
    const event: IWSClientEventSchema = {
      type: 'session',
      uid: this.uid,
      sessionToken: this.sessionToken,
      userId: this.userId as number,
    };

    await this.socket.send(event);

    await this.onRegister();
  }

  public destroy() {
    this.clear();
  }

  private onRegister() {
    return new Promise((resolve, reject) => {
      this.registerHandlerId = this.socket.addEventListener('message', (socketEvent: MessageEvent) => {
        const event: IWSServerSessionEventSchema = JSON.parse(socketEvent.data);

        // Instanbul хочет чтобы был покрыт else
        /* istanbul ignore next */
        if (event.type === 'session') {
          /* istanbul ignore next */
          if (this.uid === event.uid) {
            this.clear();

            resolve();
          }
        }
      });

      this.socketCloseHandlerId = this.socket.addEventListener('close', () => {
        this.clear();

        reject();
      });

      this.registerTimeoutId = setTimeout(() => {
        this.clear();

        reject();
      }, this.timeout);
    });
  }

  // По какой-то причне истанбул считает, что не покрыты бранчи, скорее всего он ожидает else
  private clear() {
    /* istanbul ignore next */
    if (this.registerHandlerId) {
      this.socket.removeEventListener('message', this.registerHandlerId);
      this.registerHandlerId = null;
    }

    /* istanbul ignore next */
    if (this.socketCloseHandlerId) {
      this.socket.removeEventListener('close', this.socketCloseHandlerId as string);
      this.socketCloseHandlerId = null;
    }

    /* istanbul ignore next */
    if (this.registerTimeoutId) {
      clearTimeout(this.registerTimeoutId);
      this.registerTimeoutId = null;
    }
  }
}
